import React from "react";
import CreateReports from "../components/reports/create_reports";

const CreateReportTuran = () => {
    return <CreateReports update={"turan"} sim={"Turan"} />
}

export default CreateReportTuran